import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=2690045a"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSealBlur: require('/opt/build/repo/components/Elements/SealBlur.vue').default,ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default})
